import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from '../LandingPage/FallbackPage';
import { formatRegion } from './RegionLandingPage.duck';
import './RegionLandingPage.module.css';
import { useParams } from 'react-router-dom';
import { CUSTOM_REGION_COUNTRIES } from '../../constants';
import NotFoundPage from '../NotFoundPage/NotFoundPage';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const RegionLandingPageComponent = props => {
  const { pageAssetsData, inProgress, error } = props;
  const { region } = useParams() || {};
  const formattedRegion = formatRegion(region);

  // redirect if region is not in constants
  const regionsArray = Object.keys(CUSTOM_REGION_COUNTRIES);
  const regionsArrayFormatted = regionsArray.map(region => region.toLowerCase().replace(/\s+/g, '-'));
  if (!regionsArrayFormatted.includes(formattedRegion.toLowerCase())) {
    return <NotFoundPage />
  }

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[camelize(formattedRegion)]?.data}
      inProgress={inProgress}
      error={error}
      fallbackPage={<FallbackPage error={error} />}
    />
  );
};

RegionLandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const RegionLandingPage = compose(connect(mapStateToProps))(RegionLandingPageComponent);

export default RegionLandingPage;
